<div class="bg-primary text-white mt-3 mt-md-5" id="footer">
  <ng-content></ng-content>
</div>
